import '../../App.css';

import { Header } from '../header/header';
import TextArea from 'antd/es/input/TextArea';
import { Alert, Button, InputNumber, Select } from 'antd';
import { useEffect, useState } from 'react';
import { GetAccessToken } from '../../utils/auth-utils';
import { useMsal } from '@azure/msal-react';
import { scopes } from '../../authConfig';
import { bookingPageService } from '../../services/booking-page-service';
import { useSalesChannelState } from '../../store/header-state';
import dayjs, { Dayjs } from 'dayjs';
import { DateTimePicker } from '@mantine/dates';
import { useShallow } from 'zustand/shallow';

export const OpportunityBulkUploadPage = () => {
  const { instance, inProgress } = useMsal();
  const [opportunities, setOpportunities] = useState<string>();
  const [opportunityCount, setOpportunityCount] = useState<number>();
  const [callCount, setCallCount] = useState<string>();
  const [error, setError] = useState<string>();
  const [result, setResult] = useState<string>();
  const [loading, setLoading] = useState<boolean>(false);
  const salesChannel = useSalesChannelState(useShallow((state) => state.salesChannel));
  const [selectedDate, setSelectedDate] = useState<Dayjs | null>(null);
  const [isDeleted, setIsDeleted] = useState<boolean | null>(null);
  const [isAutodialed, setIsAutodialed] = useState<boolean | null>(null);

  useEffect(() => {
    if (opportunities) {
      setOpportunityCount(opportunities.split('\n').length);
    } else {
      setOpportunityCount(undefined);
    }
  }, [opportunities]);

  return (
    <>
      <Header />
      <div className="container">
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <label className="label--title">Bulk Import Opportunities/Leads</label>
          {opportunityCount && <label>Opportunity Count: {opportunityCount}</label>}
        </div>
        <label className="label--h">Enter the Opportunity Ids and Lead Signup Ids to import, one per line</label>
        <TextArea rows={8} onChange={(e) => setOpportunities(e.target.value)} />
      </div>
      <div className="container">
        <label className="label--title">Overrides</label>
        <label className="label--h">Certain properties of the imported opportunities can be overwritten. Leave it empty to use the existing value.</label>
        <label className="label--h">To add more overrides ask a new feature to the development team.</label>
        <div className="field">
          <label className="field__label">Not Reached Count:</label>
          <InputNumber style={{ width: 150 }} min={0} stringMode onChange={(e: any) => setCallCount(e)}></InputNumber>
        </div>
        <div className="field">
          <label style={{ paddingTop: 10, marginRight: 18 }} className="field__label">
            Do Not Call Before:
          </label>
          <DateTimePicker
            placeholder="Pick date and time"
            style={{ marginTop: '10px', width: 150 }}
            valueFormat="YYYY MMM DD HH:mm"
            popoverProps={{ zIndex: 10000 }}
            //value={selectedDate.toDate()}
            minDate={dayjs().utc().add(-1, 'day').toDate()}
            timeInputProps={{ step: 900 }}
            onChange={(value) => {
              setSelectedDate(dayjs(value));
            }}
            renderDay={(date) => {
              const day = date.getDay();
              const isSaturday = day === 6;
              return (
                <div
                  style={{
                    color: isSaturday ? 'var(--text-primary)' : 'inherit',
                  }}
                >
                  {date.getDate()}
                </div>
              );
            }}
          />
        </div>
        <div className="field" style={{ marginTop: '10px' }}>
          <label className="field__label" style={{ marginRight: '78px' }}>
            Is Deleted:
          </label>
          <Select
            style={{ width: 150 }}
            options={[
              { value: true, label: 'Yes' },
              { value: false, label: 'No' },
            ]}
            value={isDeleted}
            disabled={isAutodialed === true}
            onChange={(value) => {
              setIsDeleted(value);
              if (value === true) {
                setIsAutodialed(false);
              }
            }}
          />
        </div>
        <div className="field" style={{ marginTop: '10px' }}>
          <label className="field__label" style={{ marginRight: '50px' }}>
            Is Autodialed:
          </label>
          <Select
            style={{ width: 150 }}
            options={[
              { value: true, label: 'Yes' },
              { value: false, label: 'No' },
            ]}
            value={isAutodialed}
            disabled={isDeleted === true}
            onChange={(value) => {
              setIsAutodialed(value);
              if (value === true) {
                setIsDeleted(false);
              }
            }}
          />
        </div>
      </div>
      {result && (
        <div className="container">
          <Alert message={result} type="success" />
        </div>
      )}
      {error && (
        <div className="container">
          <Alert message={error} type="error" />
        </div>
      )}
      <div className="container flex flex-end">
        <Button
          type="primary"
          loading={loading}
          disabled={opportunities === undefined || opportunities === ''}
          onClick={async (_) => {
            try {
              setLoading(true);
              const token = await GetAccessToken(instance, inProgress, scopes.salesAppointmentApi);
              const req = {
                opportunities: opportunities!.split('\n'),
                overrides: {
                  callCount: callCount ?? '',
                  doNotCallBefore: selectedDate?.toISOString() ?? null,
                  isDeleted: isDeleted ?? null,
                  isAutodialed: isAutodialed ?? null,
                },
              };
              const result = await bookingPageService.BulkUploadOpportunities(req, salesChannel, token.accessToken);
              setResult(result);
            } catch (e: any) {
              setError(e.statusText ?? e.toString());
            } finally {
              setLoading(false);
            }
          }}
        >
          Upload
        </Button>
      </div>
    </>
  );
};
